module.exports = __webpack_public_path__ + "img/delete@3x.1e41cb0e.png";